export default __webpack_public_path__ + "static/media/10percent.9630420b.svg";